import { Inject, Injectable } from '@angular/core';
import { GAService } from '@domgen/dgx-fe-ga';
import { PlanClaimsStore } from '../plan-claims/plan-claims.store';
import { take } from 'rxjs';
import { ENVIRONMENT } from '@domgen/dgx-fe-config';

export interface GATrackEvent {
  eventAction?: string;
  pagename?: string;
  eventLabel?: string;
  eventCategory?: string;
  event?: string;
  category?: string;
}

@Injectable({ providedIn: 'root' })
export class SmartFixHubAnalyticsService {
  constructor(
    private gaService: GAService,
    private planClaimsStore: PlanClaimsStore,
    @Inject(ENVIRONMENT) private environment: any
  ) {}

  trackEvent({
    eventAction = '',
    pagename = '',
    eventLabel = '',
    eventCategory = '',
    event = '',
    category = '',
  }: GATrackEvent): void {
    const basicPayload = {
      clientName: 'DG Claims',
      eventCategory,
      eventLabel,
      eventAction,
      pagename,
      event,
      category,
      customerID: this.customerId,
      customerType: 'L',
    };
    if (this.environment.hasMyAccountIntegration) {
      this.planClaimsStore.planClaims$.pipe(take(1)).subscribe((claim) => {
        const payload = {
          ...basicPayload,
          claimedAccountBrand: claim?.bookingOEM || '',
          claimedClientNAme: claim?.bookingOEM || '',
          claimedManufacturer: (claim?.item?.manufacturer as any) || '',
          claimedModelNumber: (claim?.item?.model_number as any) || '',
          productName: `${claim?.item.manufacturer || ''} ${
            claim?.item.code_description || ''
          }`.toLowerCase(),
          companyCode: (claim?.companyCode as any) || '',
          countryCode: (claim?.countryCode as any) || '',
          planNumber: (claim?.planNumber as any) || '',
        };

        if (claim) {
          const finalPayload = this.removeEmptyStringFromPayload(payload);
          this.gaService.tag(finalPayload);
        } else {
          this.gaService.tag(payload);
        }
      });
    }
  }

  removeEmptyStringFromPayload(
    payload: Record<string, any>
  ): Record<string, any> {
    return Object.fromEntries(
      Object.entries(payload).filter(([_, value]) => value !== '')
    );
  }

  get customerId(): string {
    return localStorage.getItem('customerId') || '';
  }
}
